import { render, staticRenderFns } from "./BlockRow.vue?vue&type=template&id=15fda41f&scoped=true&"
import script from "./BlockRow.vue?vue&type=script&lang=js&"
export * from "./BlockRow.vue?vue&type=script&lang=js&"
import style0 from "./BlockRow.vue?vue&type=style&index=0&id=15fda41f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fda41f",
  null
  
)

export default component.exports